import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { IonSlides, NavController } from '@ionic/angular';
import { Upload } from '../../data/schema/upload';
import { Log } from '../../log';


@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
})
export class ContentPreviewComponent implements OnInit {

  @ViewChild('slides', { static: true }) slides?: IonSlides;
  @Input() files: Upload[] = [];
  @Input() allowRemove? = false;
  @Input() showThumbnails? = false;
  @Input() viewHeight? = 150;
  @Input() thumbSize? = 70;
  @Input() uploadTitle? = 'Select a File';
  @Output() fileRemoved: EventEmitter<Upload> = new EventEmitter();

  activeIndex = 0;
  tsNow = 0;
  private currMax = 3;
  private currMin = 0;

  constructor(private navCtrl: NavController) { }

  ngOnInit() {
    this.tsNow = new Date().valueOf();
  }

  slideChanged(event: any) {
    this.slides?.getActiveIndex().then(idx => { this.activeIndex = idx; });
  }

  expandFile(file: Upload) {
    // this.navCtrl.navigateForward('/shared/content/view', { state: { file } });
  }

  next() {
    if (this.activeIndex + 1 < this.files.length) {
      this.setImage(this.activeIndex + 1);
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.setImage(this.activeIndex - 1);
    }
  }

  videoClicked(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  setImage(index: number) {
    this.slides?.slideTo(index);
    const dir = (index > this.activeIndex) ? 'left' : 'right';
    Log.debug(dir, index, this.activeIndex, this.files.length);
    this.activeIndex = index;

    if (this.showThumbnails) {
      if (dir === 'left' && this.activeIndex > 2) {
        document.getElementById('thumb' + index)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else if (dir === 'right' && this.activeIndex < this.files.length) {
        document.getElementById('thumb' + index)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
  }

  imageAdded() {
    if (this.files.length > 0) {
      this.slides?.update().then(() => {
        this.setImage(this.files.length - 1);
      });
    }
  }

  removeImage(file: Upload) {
    const idOf = this.files.indexOf(file);
    this.files.splice(idOf, 1);
    if (idOf < this.files.length) {
      this.activeIndex = idOf;
    } else if (this.files.length > 0) {
      this.activeIndex = this.files.length - 1;
    } else {
      this.activeIndex = 0;
    }
    this.fileRemoved.emit(file);
  }
}
